import React from 'react';
import {withStyles} from "@material-ui/core";
import Layout from '../../components/Layout';
import i18n from '../../i18n';
import Toolbar from "../../components/Toolbar/Toolbar";
import StructuresGrid from "../../components/Structures/StructuresGrid";

const StructuresIndex = ({classes, structures}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={ i18n.get('structures.heading_structures')}
            subtitle={`${structures.length} ${i18n.get('structures.number_of_structures')}`}
            // items={[
            //     {
            //         icon: 'add',
            //         text: i18n.get('structures.new_structure'),
            //         href: `/structures/create`,
            //     }
            // ]}
        />

        <StructuresGrid structures={structures} />
    </Layout>
);

const styles = theme => ({
    paper: {
        marginTop: theme.spacing.unit * 3,
        marginBottom: theme.spacing.unit * 3,
        padding: theme.spacing.unit * 2,
        [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
            marginTop: theme.spacing.unit * 6,
            marginBottom: theme.spacing.unit * 6,
            padding: theme.spacing.unit * 3,
        },
    },
});

export default withStyles(styles)(StructuresIndex);



// WEBPACK FOOTER //
// ./resources/assets/js/pages/structures/Index.jsx